type AssetMovie = {
  id: string;
  url: string;
  _isAssetMovie: true;
};

export const isAssetMovie = (value: unknown): value is AssetMovie => {
  if (!value) return false;
  if (typeof value !== 'object') return false;
  if ('_isAssetMovie' in value && (value as any)._isAssetMovie) return true;
  return false;
};

export default AssetMovie;
